/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';

export const PatientInfoDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const IconDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 5px;
  width: 22px;
`;

export const StayContainer = styled.div``;

export const ToDoIcon = styled(NeuIcon)`
  font-size: 12px;
  padding-right: 5px;
`;

export const CompleteIcon = styled(NeuIcon)`
  color: #00558c;
  font-size: 1.25rem;
  margin-left: -5px;
`;

export const UnableStayLabel = styled.span`
  color: #279bbb;
  font-size: 14px;
  line-height: 22px;
  font-weight: bold;
`;
